import React from "react";
import { Redirect, Switch } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { ContentRoute } from "../../../../_metronic/layout";
import Login from "./Login";

export function AuthPage() {
  return (
    <div className="d-flex" style={{ minHeight: "100vh", backgroundColor: "#FFFFFF" }}>
      <aside
        className="d-none d-lg-flex flex-column justify-content-between"
        style={{
          width: "56%",
          minHeight: "100vh",
          padding: "3.25rem 4.5rem",
          background: "linear-gradient(150deg, #F5F8FF 0%, #E8F1FF 100%)",
        }}
      >
        <div />

        <div className="d-flex flex-column align-items-center text-center mx-auto" style={{ maxWidth: "620px" }}>
          <img
            src={toAbsoluteUrl("/media/auth/neo4-login-cover.jpg")}
            alt="Acceso seguro a NEO 4"
            style={{
              width: "min(100%, 550px)",
              maxHeight: "440px",
              objectFit: "contain",
              border: "8px solid #FFFFFF",
              borderRadius: "24px",
              boxShadow: "0 18px 42px rgba(38, 71, 128, 0.18)",
            }}
          />
          <h1 className="font-weight-bolder mt-8 mb-3" style={{ color: "#182B4D", fontSize: "2rem" }}>
            Gestión de obra, conectada.
          </h1>
          <p className="mb-0" style={{ color: "#63738C", fontSize: "1rem", maxWidth: "430px" }}>
            Accede a NEO 4 para coordinar tus obras, materiales y proveedores desde un único lugar.
          </p>
        </div>

        <div className="font-weight-bold" style={{ color: "#71809A", fontSize: "0.82rem" }}>
          © {new Date().getFullYear()} NEO 4
        </div>
      </aside>

      <main className="d-flex flex-grow-1 align-items-center justify-content-center px-5 py-10">
        <div style={{ width: "100%", maxWidth: "420px" }}>
          <div className="d-lg-none mb-12 text-center">
            <img
              src={toAbsoluteUrl("/media/logo/NEO4Logo.jpg")}
              alt="NEO 4"
              style={{ width: "150px", height: "auto" }}
            />
          </div>
          <Switch>
            <ContentRoute path="/auth/login" component={Login} />
            <Redirect to="/auth/login" />
          </Switch>
        </div>
      </main>
    </div>
  );
}
